import React from 'react'

const Archive = props => (
    <svg {...props}>
        <g className="sidebar-icon">
            <path d="M60 8.311c0-.199-.052-.382-.131-.551a1.113 1.113 0 00-.254-.579L53.46 0H6.54L.384 7.182a1.094 1.094 0 00-.253.578A1.291 1.291 0 000 8.311V19h3v41h54V19h3V8.311zM7.46 2h45.08l4.286 5H3.174L7.46 2zM55 58H5V19h50v39zm3-41H2V9h56v8z"></path>
            <path d="M42 23H18v10h24V23zm-2 8H20v-6h20v6zM45 38H15v14h30V38zm-2 12H17V40h26v10z"></path>
            <path d="M22 48h5a1 1 0 100-2h-5a1 1 0 100 2zM27 44h11a1 1 0 100-2H27a1 1 0 100 2zM22 44c.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.261-.11-.521-.29-.71-.38-.37-1.04-.37-1.42 0-.18.189-.29.449-.29.71 0 .27.11.52.29.71.19.18.44.29.71.29zM31.29 46.29c-.18.189-.29.449-.29.71 0 .26.11.52.29.71.19.18.45.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.261-.11-.521-.29-.71-.37-.37-1.05-.37-1.42 0zM38 46h-1a1 1 0 100 2h1a1 1 0 100-2z"></path>
        </g>
    </svg>
)

export default Archive
